import { render, staticRenderFns } from "./PopupAdditionalFile.vue?vue&type=template&id=9e512f32&scoped=true"
import script from "./PopupAdditionalFile.vue?vue&type=script&lang=js"
export * from "./PopupAdditionalFile.vue?vue&type=script&lang=js"
import style0 from "./PopupAdditionalFile.vue?vue&type=style&index=0&id=9e512f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e512f32",
  null
  
)

export default component.exports